import { graphql, useStaticQuery } from 'gatsby';

import { QueryFragments } from './queryFragments'; // eslint-disable-line

export const useFooterQuery = () => {
  const { sanitySettingsFooter, sanitySettingsSocial } = useStaticQuery(graphql`
    query {
      sanitySettingsFooter {
        _key
        footerLinks {
          ... on SanityPageLink {
            _key
            _type
            page {
              ...PageRef
            }
            linkText
          }
        }
        footerSmallLinks {
          ... on SanityPageLink {
            _key
            _type
            page {
              ...PageRef
            }
            linkText
          }
        }
        supporters {
          image {
            ...ImageWithPreview
          }
          title
          url
        }
      }
      sanitySettingsSocial {
        socialHandles {
          link
          svg
        }
      }
    }
  `);
  return { footer: sanitySettingsFooter, social: sanitySettingsSocial } || {};
};
